// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
import { DriverAlertSlot } from "./DriverAlertSlot.gen";

export interface IDriverAlertProvisionRequest {
	slot: DriverAlertSlot;

	lanes: number | undefined;

	$type?: string | undefined;
}
export class DriverAlertProvisionRequest {
	constructor(data?: IDriverAlertProvisionRequest) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
	}

	slot: DriverAlertSlot = 0;

	lanes: number | undefined;

	static $type: string = "CoreApi.Models.DriverAlertProvisionRequest, ";
	$type?: string | undefined = DriverAlertProvisionRequest.$type;
}

